<div class="requester-details-wrapper detail-wrapper">
  <!-- <div class="backdateInfo displayFlex mb-24" *ngIf="isBackDated">
    <span><img src="assets/ic-action-info-24.svg"></span>
    <span class="fs-14 ml-8 font-weight-700">This is a backdated booking</span>
  </div>
  <div class="backdateInfo displayFlex mb-24" *ngIf="isEscortEnabled && !isBackDated">
    <span><img src="assets/ic-action-info-24.svg"></span>
    <span class="fs-14 ml-8 font-weight-700" *ngIf="authService.user.role==='SITE_ADMIN' || authService.user.role==='TRANSPORT_MANAGER'">Marshall assigned trips will start {{ preponeTripSheetInHours}} hours prior to the selected pick-up time</span>
    <span class="fs-14 ml-8 font-weight-700" *ngIf="authService.user.role==='EMPLOYEE'"> Marshall will be signed in before your pick-up</span>
  </div> -->
  <!-- <div class="requester-header">Requester details</div> -->
  <div class="requestorForm displayFlex ">
  <!-- <ng-container *ngFor="let field of config"> -->
    <!-- <ng-container *ngIf="field.elementKey !== 'paymentType' && field.elementKey !== 'department'" >
      <div class="detail-column detail" [ngClass]="{'email': field.elementKey === 'email'}" *ngIf="field.elementKey === 'paymentType' ? paymentType : requester[field.elementKey]">
           <label><span class="detail-label-text">{{field.config.displayName}}</span></label>
           <div class="detail-info ellipsis" title="{{requester[field.elementKey]}}"><span class="detail-info-text">{{requester[field.elementKey]}}</span></div>
        </div>
      </ng-container>
    </ng-container> -->
    <div *ngIf="miscellConfig?.enableRepresentative " class="recipe-box mb-16">
      <label><span class="detail-label-text"> Share with</span></label>
      <div class="displayFlex mt-8">
        <span class="detail-info-text" [(ngModel)]="recipientName" ngDefaultControl>{{recipientName}}</span>
        <span> <img [src]="srcPath" alt="icon to add recipient"
          class="addRecipientIcon" (click)="openRecipientModal=true"></span>
      </div> 
    </div>
  </div>
</div>
<app-popover *ngIf="openRecipientModal" size="recipient-model" (closeCallback)="openRecipientModal=false" [sendHeader]="true" [subheaderText]="subheaderText">
  <div popover-header class="popover-header" class="recipient-header">Select Recipient</div>
  <div popover-content class="search-recipient-container ">
    <div class="mb-16 displayFlex">
      <span class="recipientFormLabel">Name</span>
      <span class="empNameInput">
        <input type="text" (keypress)="validateInput($event)" [(ngModel)]="employeeDetails.name"
          [ngClass]="isTyping  ? 'select-input2 selectInput' : 'select-input selectInput'"
          placeholder="Search to add firm member"
          #search (keyup)="getEmployee(search.value)">
      </span>
    </div>
    <div class="mb-16 displayFlex">
      <span class="recipientFormLabel">Employee ID</span>
      <span>
        <input type="text" placeholder="Type here" [(ngModel)]="employeeDetails.emplID" class="inputField" disabled>
      </span>
    </div>
    <div class="mb-16 displayFlex">
      <span class="recipientFormLabel">Email ID</span>
      <span>
        <input type="text" placeholder="Type here" [(ngModel)]="employeeDetails.emailID" class="inputField" disabled>
      </span>
    </div>
    <div class="displayFlex">
      <span class="recipientFormLabel">Mobile</span>
      <span class="mobileField">
        <input type="text" placeholder="+91" class="codeField phnInput" [(ngModel)]="employeeDetails.code" disabled>
        <input type="text" placeholder="Phone (Optional)" class="phnNumField phnInput"
          [(ngModel)]="employeeDetails.phoneNum" disabled>
      </span>
    </div>
    <ng-template [ngIf]="showList && empList.length ">
      <ul class="select-list">
        <li class="ellipsis" *ngFor="let item of empList" (click)="selectedEmp(item)">
          {{item.employeeName}} ({{item.employeeId}})
        </li>
      </ul>
    </ng-template>
  </div>
  <div popover-actions class="submit-button align-item-center displayFlex">
    <app-button type="plainText" text="Delete" class="mr-20" (clickCallback)="deleteRecipient()" [disabled]="!enableBtn"></app-button>
    <app-button type="primaryFilled" text="Save" (clickCallback)="submitRecipient()" [disabled]="!enableBtn" [btnType]="successBtn"></app-button>
  </div>
</app-popover>
<app-dialog
  *ngIf="showWarningDialog"
  titleText="Warning"
  type="confirm"
  [buttonText]="['Yes', 'No']"
  (approveCallback)="makeButtonSubmitEnable()"
  (dismissCallback)="showWarningDialog=false"
  (closeCallback)="showWarningDialog=false"
  icon="true"
  src="assets/ic-ui-warning-24.svg"
>
Are you sure you want to delete <span class="font-weight-700">{{recipientName}}</span> as your recipient?
</app-dialog>